import {RootState} from "../../../store";

export const getFooterIsShow = (state: RootState) => state.footerReducer.isShowFooter;
